export default {
  chartLegend: {
    buyUp: 'Buy Up',
    sellDown: 'Sell Down',
    unidentified: 'Unidentified',
  },

  listTitleTable: {
    time: 'TIME', // hh:mm
    bidVolume: 'BID VOLUME',
    bid: 'BID',
    volumeDone: 'VOLUME DONE',
    priceDone: 'PRICE DONE',
    type: 'TYPE',
    ask: 'ASK',
    askVolume: 'ASK VOLUME',
    totalVolume: 'TOTAL VOLUME',
  },
};
